import { combineReducers } from "redux";
import form from "./formReducer";
import user from "./userReducer";
import templates from "./templateReducer";
import formConfig from "./formConfigurationReducer";
import templateProgressType from "./templateProgressReducer";
import initialState from "./initialState";
import integration from "./integrationReducer";

const appReducer = combineReducers({
  form,
  user,
  templates,
  formConfig,
  templateProgressType,
  integration,
});

export default function rootReducer(state, action) {
  if (action.type === "RESET_STATE") {
    return appReducer(initialState, action);
  }

  return appReducer(state, action);
}
